import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=201900ca"
import script from "./Cadastro.vue?vue&type=script&lang=ts"
export * from "./Cadastro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports